module.exports = __webpack_public_path__ + "static/image/lesson_path_2.svg?fe33269876aa1695b3f8c62bb8afc495";